<template>
    <div class="sorting-container">
      <span class="sorting-label">{{ $t('status') }} :</span>
      <div class="sorting-buttons">
        <CButton :class="getButtonClass('')" @click="$emit('sortChange', '')">
          {{ getLabel('total') }}
        </CButton>
        <CButton :class="getButtonClass('A')" @click="$emit('sortChange', 'A')">
          {{ getLabel('success') }}
        </CButton>
        <CButton :class="getButtonClass('V')" @click="$emit('sortChange', 'V')">
          {{ getLabel('cancel') }}
        </CButton>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'OrderStatusFilter',
    props: {
      filterVal: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: '' // 'order', 'bills', or ''
      }
    },
    methods: {
      getButtonClass(key) {
        return this.filterVal === key ? 'btn btn-active' : 'btn btn-inactive';
      },
      getLabel(key) {
        if (this.type === 'order') {
          switch (key) {
            case 'total': return this.$t('orderTotal');
            case 'success': return this.$t('orderSuccess');
            case 'cancel': return this.$t('orderCancel');
          }
        } else if (this.type === 'bills') {
          switch (key) {
            case 'total': return this.$t('billTotal');
            case 'success': return this.$t('billsSuccess');
            case 'cancel': return this.$t('billsCancel');
          }
        }else if( this.type === 'cash'){
          switch (key) {
            case 'total': return this.$t('viewAllFood');
            case 'success': return this.$t('totalCashIn');
            case 'cancel': return this.$t('totalCashOut');
          }
        }else {
          switch (key) {
            case 'total': return this.$t('totals');
            case 'success': return this.$t('success');
            case 'cancel': return this.$t('cancel');
          }
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .sorting-container {
    display: flex;
    align-items: center;
    background-color: #f8f9fa;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 10px;
    border: 1px solid #dfe1e5;
  }
  .sorting-label {
    margin-right: 10px;
    color: #47525e;
    font-weight: 500;
  }
  .sorting-buttons {
    display: flex;
    gap: 10px;
  }
  .btn-inactive {
    background-color: white;
    color: #47525e;
  }
  .btn-inactive:hover {
    background-color: #e9ecef;
  }
  .btn-active {
    background-color: #3abc98;
    color: white;
  }
  </style>
  